import { CountryEnv } from "@type/country";

const _countryEnv: CountryEnv = {
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_US_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_US_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_US_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_US_UQ || "",
  faqUrl: "https://faq-us.uniqlo.com/"
};

export default _countryEnv;
